export const ITEMS = {
  clickDealsClickId: 'clickDeals_clickID',
  features: 'features-store',
  lastRetailersTableRefreshNumber: 'last_retailers_table_refresh_number',
  targetRetailersTableRefreshNumber: 'target_retailers_table_refresh_number',
  token: 'token',
  userId: 'user_id',
  xuid: 'xuid',
  isLoggingEnabled: 'logger',
  lpTest: 'lp_test',
  guestBalance: 'guestBalance',
  isDownloadAppBannerShown: 'isDownloadAppBannerShown',
  isSignUpBannerShown: 'isSignUpBannerShown',
  isDownloadExtensionBannerShown: 'isDownloadExtensionBannerShown',
  storage: 'storage',
  completeSignUpModalDelay: 'completeSignUpModalDelay',
  congratulateSignupModal: 'congratulateSignupModal',
  sessionPair: 'sessionPair',
  showListsTooltip: 'showListsTooltip',
  isUserResubscribed: 'isUserResubscribed',
  globalRecentSearches: 'globalRecentSearches',
  isXPlatformOnSearchClosed: 'isXPlatformOnSearchClosed',
  isXPlatformOnHomeClosed: 'isXPlatformOnHomeClosed',
  sweOnboardingUserId: 'sweOnboardingUserId',
  sweOnboardingRedirect: 'sweOnboardingRedirect',
  sweOnboardingEventSent: 'sweOnboardingEventSent',
  inApp: 'in_app',
};
